<template>
  <dv-full-screen-container>
    <div class="rfirfa">
      <div class="rfirfa_container">
        <div class="rfirfa_one">
          <rfi></rfi>
        </div>
        <div class="rfirfa_one">
          <rfa></rfa>
        </div>
      </div>
    </div>
  </dv-full-screen-container>

</template>

<script>
import rfi from "@/outside/rfirfa/rfi";
import rfa from "@/outside/rfirfa/rfa";

export default {
  name: "rfirfa_manage",
  props: ['project_id'],
  data() {
    return {}
  },
  methods: {},
  components: {rfi, rfa},
  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
.rfirfa {
  width 100%
  height 90%
  background-image url("../../assets/img/sm_backgroud.jpg")
  background-size 100% 100%
  background-repeat no-repeat

}

.rfirfa_container {
  width 100%
  height 100%
  background-color #0D0E1380
  //background-color rgba(13,14,19,0.7)
  display flex
  justify-content space-around
  align-items center
}

.rfirfa_one {
  width 40%
  height 90%
  border 1px solid #EEEEEE
  background-color #0D0E1380
  //background-color rgba(13,14,19,0.7)
}
</style>



// WEBPACK FOOTER //
// src/outside/rfirfa/main.vue